import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {SessionService} from "../state/session.service";

export const adminOrManagerAuthGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);
  const roles = session.user?.roles ?? [];
  const isAdminOrManager = roles.includes('ADMIN') || roles.includes('MANAGER');

  if (session.authToken && isAdminOrManager) {
    return true;
  }

  return router.createUrlTree(['/conversation-overview']);
};
